// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6454":"Widgets","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"6454":"da842079","7051":"04f049d9"}[chunkId] + ".chunk.css";
};